module.exports = __webpack_public_path__ + "static/media/Madfit_Website_13.1b4703f5.jpg";